export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 rounded-2xl overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 p-8 md:p-12 lg:p-16">
            <div className="flex-1 text-center lg:text-left">
              <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-medium mb-4 backdrop-blur-sm">
                <i className="ri-smartphone-line text-sm"></i>
                移动畅享
              </span>
              <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-background-50 mb-4">
                随时随地问，好瓜不错过
              </h2>
              <p className="text-background-50/80 text-sm md:text-base leading-relaxed max-w-lg mx-auto lg:mx-0 mb-6">
                五一吃瓜网移动端适配完美，无论在通勤路上还是茶余饭后，打开手机即可浏览最新吃瓜资讯。第一时间推送热门爆料，让你永远走在吃瓜最前线。
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <button className="w-full sm:w-auto px-8 py-3 bg-background-50 text-primary-600 font-medium text-sm rounded-full hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-apple-line mr-2"></i>iOS 下载
                </button>
                <button className="w-full sm:w-auto px-8 py-3 bg-background-50/15 text-background-50 font-medium text-sm rounded-full border border-background-50/30 hover:bg-background-50/25 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-android-line mr-2"></i>Android 下载
                </button>
              </div>
            </div>
            <div className="flex-shrink-0">
              <div className="relative w-56 md:w-64 aspect-[9/16] rounded-2xl overflow-hidden bg-background-200 shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20showing%20a%20news%20and%20entertainment%20app%20interface%20with%20trending%20topics%20and%20headlines%2C%20clean%20UI%20design%2C%20warm%20white%20background%2C%20mobile%20app%20mockup%20style%2C%20professional%20product%20photography&width=576&height=1024&seq=app-mockup&orientation=portrait"
                  alt="五一吃瓜网移动端界面展示"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}